export default function initAppearAnim() {
    const $appearAnimElements = document.querySelectorAll('.anim-element');

    $appearAnimElements.forEach($element => {
        new AppearAnim($element as HTMLElement);
    });
}

/**
 * Add class "appear" on elements with class "anim-element"
 */
class AppearAnim {
    private $element: HTMLElement;
    private observer: IntersectionObserver;

    constructor($element: HTMLElement) {
        this.$element = $element;
        this.onIntersection = this.onIntersection.bind(this);

        const options = {
            threshold: 0.1
        };

        this.observer = new IntersectionObserver(this.onIntersection, options);
        this.observer.observe(this.$element);
    }

    /**
     * IntersectionObserver callback
     * @param {IntersectionObserverEntry[]} entries
     */
    private onIntersection(entries: IntersectionObserverEntry[]) {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                this.$element.classList.add('appear');
                this.observer.unobserve(this.$element); // Stop observing after the class is added
            }
        });
    }
}
